import React from 'react';
import FormulaireCHETOM from '../components/FormulaireChetom';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <FormulaireCHETOM />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
